module.exports = __webpack_public_path__ + "img/whatIn.f5a855de.png";